import { render } from "./connect_mp.vue?vue&type=template&id=4fd2695a"
import script from "./connect_mp.vue?vue&type=script&lang=js"
export * from "./connect_mp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__